import React from 'react';
import { NavigationItem } from '../../ui-toolkit';
import { useOnClickLogout } from './hooks/useOnClickLogout';

export const LogOutNavigationItem: React.FC = () => {
  const onClickLogout = useOnClickLogout();
  return <NavigationItem data-id={`Sign Out`} data-test-id={'sign-out'} onClick={onClickLogout} text={`Log Out`} />;
};
